import React, { useContext } from 'react';
import { BrowserRouter, Route, useHistory } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Fade,

  Typography,
} from '@material-ui/core';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import { Store } from '../Store';
import { setOrderType } from '../actions';

export default function SelectBranch(props) {
  const { state, dispatch } = useContext(Store);
  const styles = useStyles();
    const history = useHistory(); 
    let {setting} = state.userData;
    console.log(setting);

  
  const chooseHandler = (merchantCode) => {
    history.push('/collection-mode?merchantCode=' + merchantCode);
    window.location.reload();
  };

  
  return (

    <>
      <Fade in={true}>
        <Box className={[styles.root, styles.navy]} style={{ backgroundColor: setting.themeColor }} >
          <Box className={[styles.main, styles.center]}>
            {/* <img src={state.selectedLogo} height='90px' width='120px' /> */}
            <Typography
              className={[styles.center, styles.title3]}
              gutterBottom
              variant="h3"
              component="h3"
              id="title1"
              style={{color:setting.themeTxtColor, padding:"10px", fontFamily: setting.themeSecondaryFontFam}}
            >
              Please select your nearest branch
            </Typography>
            <Box 
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                padding: '20px',
                maxWidth: '1200px',
                margin: '0 auto',
                width: '100%',
                maxHeight: 'calc(100vh - 200px)',
                overflowY: 'auto',
                overflowX: 'hidden',
                justifyContent: 'center'
              }}
            >
              <Box
                onClick={() => chooseHandler(setting.merchantCode)}
                style={{
                  flex: '1 1 calc(50% - 16px)',
                  minWidth: '250px',
                  maxWidth: '400px',
                  backgroundColor: setting.themeTxtColor,
                  borderRadius: '12px',
                  padding: '20px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  border: `2px solid ${setting.themeColor}20`,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '12px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                }}
              >
                <Box style={{
                  backgroundColor: setting.themeColor,
                  borderRadius: '8px',
                  padding: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img
                    src={setting.logoImg}
                    alt="Logo"
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: 'contain'
                    }}
                  />
                </Box>
                <Typography
                  style={{
                    color: setting.themeColor,
                    fontFamily: setting.themeSecondaryFontFam,
                    fontSize: '14px',
                    fontWeight: '600',
                    textAlign: 'center',
                    lineHeight: '1.3',
                    wordBreak: 'break-word'
                  }}
                >
                  {setting.address || "BRANCH NAME NOT AVAILABLE"}
                </Typography>
              </Box>
              {setting.branches && setting.branches.map((branch, index) => {
                console.log('Branch object:', branch);
                const branchDisplay = branch.name || branch.branchName || branch.address || branch.location || JSON.stringify(branch) || "BRANCH NAME NOT AVAILABLE";
                return (
                  <Box
                    key={index}
                    onClick={() => chooseHandler(branch.merchantCode)}
                    style={{
                      flex: '1 1 calc(50% - 16px)',
                      minWidth: '250px',
                      maxWidth: '400px',
                      backgroundColor: setting.themeTxtColor,
                      borderRadius: '12px',
                      padding: '20px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      border: `2px solid ${setting.themeColor}20`,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '12px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                  >
                    <Box style={{
                      backgroundColor: setting.themeColor,
                      borderRadius: '8px',
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img
                        src={setting.logoImg}
                        alt="Branch Logo"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: 'contain'
                        }}
                      />
                    </Box>
                    <Typography
                      style={{
                        color: setting.themeColor,
                        fontFamily: setting.themeSecondaryFontFam,
                        fontSize: '14px',
                        fontWeight: '600',
                        textAlign: 'center',
                        lineHeight: '1.3',
                        wordBreak: 'break-word'
                      }}
                    >
                      {branchDisplay}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>

      </Fade>
    </>

  );
}

{/* <button onClick={() => {
  props.history.push(`/?` + window.location.href.split('?')[1]);
}} className='btn btn-dark ms-4 mb-4' style={{width:"80px",textAlign:"center"}}>
  BACK
</button> */}